import React, { useState, useContext, useEffect, useRef } from 'react';

/**
 * DWT dependencies
 */

import { ContributorsContext } from '../Contributors/ContributorsContext';
import { ModalContext } from '../Modal/ModalContext';

/**
 * DWT hooks
 */

import useModal from '../../hooks/useModal';

/**
 * DWT components
 */

import LoadMoreButton from '../LoadMoreButton';
import Modal from '../Modal/Modal';
import Grid from '../Grid';

const ContributorTab = ({ prhData, recordCount, searchTerm, loadMore, loading }) => {
  const c = useContext( ContributorsContext );
  const [ context, setContext ] = useState( c );

  const modalRef = useRef( null );

  const {
    modalClass,
    modalData,
    onClickOpenModal,
    onClickCloseModal
  } = useModal( prhData, modalRef, context );

  const error = null;

  useEffect( () => {
    setContext({
      featureBy: 'contributors',
      entry: 'automatic'
    });
  }, [] );

  return (
    <ModalContext.Provider value={{ onClickOpenModal }}>
      <ContributorsContext.Provider value={ { featureBy: 'contributors', entry: 'automatic' } }>
        <div className="max-w-lg min-h-[1000px] my-32 m-auto">
          { recordCount > 0 && (
            <h1>{ recordCount } results for &ldquo;{ searchTerm }&rdquo;</h1>
          ) }

          <div className="list-wrapper container grid gap-20 grid-cols-2 col-span-full md:grid-cols-3 lg:grid-cols-4 my-32 min-h-[1000px]">
            <Grid
              context={ context }
              data={ prhData }
              showMetadata
              error={ error }
              loading={ loading }
            />
          </div>

          { recordCount > prhData.length &&
                        <LoadMoreButton makeRequest={ loadMore } loading={ loading } />
          }

          <Modal
            context={ context }
            modalData={ modalData }
            modalClass={ modalClass }
            onClose={ onClickCloseModal }
            modalType={ context.featureBy }
            ref={ modalRef }
          />
        </div>
      </ContributorsContext.Provider>
    </ModalContext.Provider>
  );
};

export default ContributorTab;
